import React, { useMemo } from "react";
import { Stack, Typography, Box } from "@mui/material";
import { People as PeopleIcon, Work as WorkIcon } from "@mui/icons-material";
import UserAvatar from "./UserAvatar";
import { getTranslation } from "common/utilities";
import { useTranslations } from "hooks";

interface MonitorParticipantsProps {
  iduser: number | null;
  userfullname: string | null;
  user_picture: string | null;
  jsongroups: string | null;
  jsonroles: string | null;
  isAdmin?: boolean;
}

const MonitorParticipants: React.FC<MonitorParticipantsProps> = ({
  iduser,
  userfullname,
  user_picture,
  jsongroups,
  jsonroles,
  isAdmin,
}) => {
  const translations = useTranslations();

  const groups = useMemo(() => {
    if (!jsongroups) return [];
    try {
      const parsed = typeof jsongroups === "string" ? JSON.parse(jsongroups) : jsongroups;
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }, [jsongroups]);

  const roles = useMemo(() => {
    if (!jsonroles) return [];
    try {
      const parsed = typeof jsonroles === "string" ? JSON.parse(jsonroles) : jsonroles;
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }, [jsonroles]);

  if ((groups.length > 0 || roles.length > 0) && !iduser) {
    return (
      <Stack spacing={0.5}>
        {groups.map((g: any) => (
          <Stack key={g.idgroup} direction="row" alignItems="center" spacing={0.5}>
            <PeopleIcon sx={{ fontSize: "1rem", color: "action.active" }} />
            <Typography variant="caption" sx={{ fontWeight: 500 }}>
              {g.groupname}
            </Typography>
          </Stack>
        ))}
        {roles.map((r: any) => (
          <Stack key={r.idrole} direction="row" alignItems="center" spacing={0.5}>
            <WorkIcon sx={{ fontSize: "1rem", color: "action.active" }} />
            <Typography variant="caption" sx={{ fontWeight: 500 }}>
              {r.rolename}
            </Typography>
          </Stack>
        ))}
      </Stack>
    );
  }

  if (!isAdmin) {
    return (
      <Typography color="textSecondary" variant="body2">
        {getTranslation(translations, "monitor.no_participant")}
      </Typography>
    );
  }

  return null;
};

export default MonitorParticipants;
